export default "__VITE_ASSET__CVO$Bfz3__"